export const readFileSync = () => { throw new Error("readFileSync: node builtin unavailable in the browser; preload data via provideRawText()"); };